import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-pixxikat.mjs";
import { render } from "lit-html";
import { wait, PIXXIKAT, getRandomNumber, B } from "../../global.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

import Stock from "./Pixxikat.json";
const stock: { category: string; folder: string; count: number }[] = Stock;

const HOLIDAY = 1;

export class HbPixxiKat extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private modal: ModalInterface;

    private jewel: HTMLElement;
    private form: HTMLFormElement;
    private copy: HTMLButtonElement;
    private shareBtn: HTMLButtonElement;

    private search: HTMLInputElement;
    private searchCategory: HTMLElement;
    private searchCategories: HTMLUListElement;
    private searchBtn: HTMLButtonElement;
    private stock: HTMLElement;

    private showAll = true;
    private stockCategory = stock[HOLIDAY].folder;
    private stockItem = getRandomNumber(1, stock[HOLIDAY].count);
    private stockCount = stock[HOLIDAY].count;

    constructor() {
        super();
        render(template(null), this);

        this.jewel = this.querySelector("#hb-pixxikat")!;
        this.form = this.querySelector("#hb-pixxikat-form")!;
        this.copy = this.querySelector("#hb-pixxikat-copy")!;
        this.shareBtn = this.querySelector("button[type=submit]")!;

        this.search = this.querySelector("#hb-pixxikat-stock-search")!;
        this.searchCategory = this.querySelector(
            "#hb-pixxikat-stock-categories"
        )!;
        this.searchCategories = this.searchCategory
            .firstElementChild as HTMLUListElement;
        this.searchBtn = this.querySelector("#hb-pixxikat-stock-magic")!;
        this.stock = this.querySelector("#hb-pixxikat-stock")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                // need user interaction
                //if (this.stockImage.paused) this.stockImage.play();
                //if (this.aiImage.paused) this.aiImage.play();
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-pixxikat",
            override: true
        };

        this.modal = new Modal(this.jewel, modalOptions, instanceOptions);
    }

    connectedCallback() {
        //this.renderStock();
        this.addStockListeners();

        this.form.addEventListener("submit", this.share.bind(this));

        this.copy.addEventListener("click", async (event) => {
            const url = `${B}/z/${this.stockCategory}-${this.stockItem}`;
            await navigator.clipboard.writeText(url);
            alert("This Pixxikat™ B-Emoji has been copied to your clipboard!");
        });

        this.heartbank.addAuthStateListener((user) => {
            render(template(user), this);
        });
    }

    private addStockListeners() {
        this.search.addEventListener("focus", () => {
            this.renderCategories(this.search.value);
            this.searchCategory.classList.remove("hidden");
        });

        this.search.addEventListener("blur", async () => {
            await wait(0.1); // needed for click select
            this.searchCategory.classList.add("hidden");
        });

        this.search.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.renderCategory();
            }
        });

        this.search.addEventListener("keyup", (event: KeyboardEvent) => {
            this.renderCategories(this.search.value);
        });

        this.searchBtn.addEventListener(
            "click",
            this.renderCategory.bind(this)
        );
    }

    private renderCategory() {
        this.showAll = true;
        this.search.value = "";
        this.search.placeholder = "Search for Pixxikat™ B-Emoji";
        this.renderStock();
    }

    private renderCategory2() {
        if (this.searchCategories.childElementCount > 0) {
            const item = this.searchCategories
                .firstElementChild as HTMLLIElement;
            this.stockCategory = item.dataset.category!;
            this.stockItem = 1;
            this.stockCount = parseInt(item.dataset.count!);
            this.showAll = false;
            this.renderStock();
            this.search.blur();
        }
    }

    private renderCategories(search: string) {
        this.searchCategories.innerHTML = "";

        for (const item of stock)
            if (
                search === "" ||
                item.category
                    .toLowerCase()
                    .includes(search.trim().toLowerCase())
            ) {
                const li = document.createElement("li");
                li.classList.add(
                    "block",
                    "px-4",
                    "py-2",
                    "hover:bg-gray-100",
                    "dark:hover:bg-gray-600",
                    "dark:hover:text-white"
                );
                li.dataset.category = item.folder;
                li.dataset.count = item.count.toString();
                li.textContent = item.category;
                li.onclick = () => {
                    this.stockCategory = item.folder;
                    this.stockItem = 1;
                    this.stockCount = item.count;
                    this.search.value = "";
                    this.search.placeholder = item.category;
                    this.showAll = false;
                    this.renderStock();
                };
                this.searchCategories.appendChild(li);
            }

        if (this.searchCategories.childElementCount === 0) {
            const li = document.createElement("li");
            li.classList.add(
                "block",
                "px-4",
                "py-2",
                "hover:bg-gray-100", //"text-gray-500",
                "dark:hover:bg-gray-600", //"dark:text-gray-400"
                "dark:hover:text-white"
            );
            li.textContent = "🙀 SHOW ALL"; // "No Categories Found";
            li.onclick = () => {
                this.showAll = true;
                this.search.value = "";
                this.search.placeholder = "Search for Pixxikat™ B-Emoji";
                this.renderStock();
            };
            this.searchCategories.appendChild(li);
        }
        // else {
        //     const li = document.createElement("li");
        //     li.classList.add(
        //         "block",
        //         "px-4",
        //         "py-2",
        //         "hover:bg-gray-100",
        //         "dark:hover:bg-gray-600",
        //         "dark:hover:text-white"
        //     );
        //     li.textContent = "🙀 SHOW ALL";
        //     li.onclick = () => {
        //         this.showAll = true;
        //         this.search.value = "";
        //         this.search.placeholder = "Search for Pixxikat™ B-Emoji";
        //         this.renderStock();
        //     };
        //     this.searchCategories.prepend(li);
        // }
    }

    // TODO: show spinner if await is too long
    async show(category: string, item: string) {
        if (category) this.stockCategory = category;
        if (item) this.stockItem = parseInt(item);
        await this.renderStock();
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private async renderStock() {
        this.stock.innerHTML = "";

        const folders = this.showAll
            ? stock.map((item) => item.folder)
            : [this.stockCategory];

        for (const folder of folders) {
            const category =
                stock[stock.findIndex((item) => item.folder === folder)];
            for (let i = 1; i <= category.count; i++) {
                const img = document.createElement("img");
                img.className =
                    "w-full h-auto rounded-xl object-cover ring-amber-600";
                img.src = `${PIXXIKAT}/${folder}/${i}/${i}.gif`;

                img.onclick = () => {
                    this.stockCategory = folder;
                    this.stockItem = i;
                    this.resetImages();
                    img.classList.add("ring-5");
                };

                this.stock.appendChild(img);
            }
        }

        this.stock.querySelector("img")?.click();
    }

    private resetImages() {
        this.stock
            .querySelectorAll("img")
            .forEach((img) => img.classList.remove("ring-5"));
    }

    private async share(event: Event) {
        event.preventDefault();
        this.shareBtn.disabled = true;

        let file: File | null = null;
        if (this.heartbank.isAdmin()) {
            const response = await fetch(
                `${PIXXIKAT}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.gif`
            );
            const blob = await response.blob();
            file = new File([blob], "B-Emoji.gif", { type: "image/gif" });
        }

        const shareData = {
            title: "Pixxikat™ B-Emoji",
            //text: "",
            url: `${B}/z/${this.stockCategory}-${this.stockItem}`,
            files: file ? [file] : []
        };
        //console.log(shareData);

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                console.log("Shared successfully");
            } catch (error: any) {
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    console.warn("Sharing was cancelled:", error);
                } else {
                    console.error(error);
                }
            }
        } else {
            alert("Sorry, Web Share is not supported on this device.");
        }

        this.shareBtn.disabled = false;
    }
}
